import gql from "graphql-tag";

const MEMBER_TIMERANGE_MUTATION = gql` 
  mutation EditVolunteer ($volunteerData: VolunteerEditInput!) {
    editVolunteer(volunteerData: $volunteerData) {
      LookupId
      Name
      StartDate
      EndDate
      Roles {
        GroupMemberRoleId
        Role
        RoleStartDate
        RoleEndDate
      }
      PrimaryContact
      GroupMemberDateRangeId
      GroupMemberId
      SystemRecordId
    }  
  }
`;
export default MEMBER_TIMERANGE_MUTATION;